import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './Store/Store';
import './Style/Global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// Prevent browser PWA "Install app" popup / prompt
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  return false;
});

// Unregister service worker to prevent install prompts
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log("ServiceWorker unregistered");
    }
  });
}